
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";


const firebaseConfig = {
  apiKey: "AIzaSyAdgx80EFQTsKC-vY3hDaykq793rKmuo2I",
  authDomain: "omrali-5d930.firebaseapp.com",
  projectId: "omrali-5d930",
  storageBucket: "omrali-5d930.firebasestorage.app",
  messagingSenderId: "501254871159",
  appId: "1:501254871159:web:2adc5a1bdae18991504e72",
  measurementId: "G-BMVCNP28ZJ"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);     